(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-kl-avis"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hm-kl-reviews'))customElements.define('hm-kl-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.hm-review-track');this.cards=[...this.querySelectorAll('.hm-review-card')];this.dots=[...this.querySelectorAll('.hm-dots button')];this.dots.forEach((b,i)=>b.addEventListener('click',()=>this.go(i)));this.track.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>{const center=this.track.scrollLeft+this.track.clientWidth/2;let i=0,dist=Infinity;this.cards.forEach((c,n)=>{const x=Math.abs(c.offsetLeft-this.track.offsetLeft+c.clientWidth/2-center);if(x<dist){i=n;dist=x}});this.select(i)},80)});this.resize=new ResizeObserver(()=>this.go(this.active ?? Math.min(1,this.cards.length-1),false));this.resize.observe(this);this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.contains(e.target));if(i>=0)this.go(i)});}
select(i){this.active=i;this.cards.forEach((c,n)=>c.classList.toggle('is-selected',n===i));this.dots.forEach((c,n)=>c.setAttribute('aria-current',String(n===i)))}go(i,smooth=true){const c=this.cards[i];if(!c)return;this.select(i);this.track.scrollTo({left:c.offsetLeft-this.track.offsetLeft-(this.track.clientWidth-c.clientWidth)/2,behavior:smooth?'smooth':'instant'})}disconnectedCallback(){this.resize?.disconnect();clearTimeout(this.timer)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-shoe-main"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hm-shoe-product'))customElements.define('hm-shoe-product',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const slides=[...this.querySelectorAll('.hm-shoe-slide')],thumbs=[...this.querySelectorAll('.hm-shoe-thumbs button')],dialog=this.querySelector('dialog');
 const show=i=>{slides.forEach((s,n)=>s.hidden=n!==i);thumbs.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));};
 thumbs.forEach((b,i)=>b.addEventListener('click',()=>show(i)));
 this.querySelector('.hm-shoe-variant').addEventListener('change',e=>{let id=e.target.selectedOptions[0].dataset.media;let i=slides.findIndex(s=>s.dataset.mediaId===id);if(i>=0)show(i);const input=this.querySelector('input[name="id"]');input.value=e.target.value;input.dispatchEvent(new Event('change',{bubbles:true}));const url=new URL(location.href);url.searchParams.set('variant',e.target.value);history.replaceState({},'',url);});
 const bundle=this.querySelector('.hm-shoe-product-form');const translateUnit=()=>bundle.querySelectorAll('.show-price-per-item .rapi-bundles__bar-price,.show-price-per-item .rapi-bundles__bar-full-price').forEach(n=>n.childNodes.forEach(t=>{if(t.nodeType===Node.TEXT_NODE&&t.textContent.includes('/unit'))t.textContent=t.textContent.replace('/unit',this.dataset.hmUnit||'/sac');}));this.bundleObserver=new MutationObserver(translateUnit);this.bundleObserver.observe(bundle,{childList:true,subtree:true,characterData:true});translateUnit();
 this.querySelectorAll('.hm-shoe-zoom').forEach(b=>b.addEventListener('click',()=>{dialog.querySelector('img').src=b.querySelector('img').currentSrc;dialog.showModal();}));
 this.querySelector('.hm-shoe-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
 const sticky=this.querySelector('.hm-shoe-sticky'),atc=this.querySelector('.hm-shoe-atc');this.observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0;});this.observer.observe(atc);sticky.addEventListener('click',()=>this.querySelector('.hm-shoe-buybox').scrollIntoView({behavior:'smooth',block:'start'}));
 }
 disconnectedCallback(){this.observer?.disconnect();this.bundleObserver?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-shoe-photos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hm-shoe-photos'))customElements.define('hm-shoe-photos',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const b=this.querySelector('button');b.addEventListener('click',()=>{const cards=[...this.querySelectorAll('.hm-shoe-extra-photo[hidden]')];cards.slice(0,3).forEach(c=>c.hidden=false);if(cards.length<=3)b.hidden=true;});}});
  } catch(e) { console.error(e); }
})();
})();
